<template>
    <table class="table table-hover">
        <tbody>
            <tr v-for="item in list" :key="item.id">
                <td class="col-2" style="color: #778899; font-size: 16px;">{{ item.title }}</td>
                <td class="col-8" style="color: #589ee4; line-height: 23px;">
                    <span class="hover" @click="toProblem(item.pbid)">AL {{ item.pbid }}. {{ item.problemName }}</span>
                </td>
                <td class="col-2">
                    <!-- <i class="el-icon-check" style="color:#1fa725; font-weight: 1600; font-size: 20px; line-height: 23px; float: right;"></i> -->
                    <i class="el-icon-edit" style="cursor: pointer; color:#409EFF; font-weight: 600; font-size: 16px; line-height: 23px; float: right;" @click="toProblem(item.pbid)"></i>
                    <span style="color: #778899; cursor: pointer; font-size: 16px; float: right; margin-right: 10px;" @click="toProblem(item.pbid)">打卡</span>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import $ from 'jquery'
    export default {
        props:["cId"],
        data() {
            return {
                title:'',
                pbid:'',
                catalogId:'',
                error_message:'',

                list:[],
            }
        },
        mounted() {
            // console.log("cid == >", this.cId)
            this.catalogId = this.cId

            this.GetCatalogProblem()
        },
        methods: {
            GetCatalogProblem() {
                const vue = this

                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/catalogProblem/read/',
                    type:'post',
                    data: {
                        catalogId: vue.cId
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("获取课程习题成功了")
                            vue.error_message = ""
                            vue.list = JSON.parse(resp.catalogProblem);
                            console.log(vue.list)
                        } else {
                            vue.error_message = resp.error_message
                        }
                    },
                    error(resp) {
                        console.log("获取课程习题彻底失败了, resp == >", resp)
                    }
                })
            },
            toProblem(id) {
                let routeData = this.$router.resolve({
                    path:`/Problem/Content/${id}`,
                });
                window.open(routeData.href, '_blank');
            }
        }
    }
</script>

<style scoped>
.hover {
    cursor: pointer;
}
</style>